


export const mapSize = () => {

  const mapBlock = document.querySelector(".footer__map");
  const footerBlock = document.querySelector(".footer__inner");

  function mapResize() {
    if ( window.innerWidth < 769 ) {
       mapBlock.style.width = window.innerWidth - mapBlock.offsetLeft - footerBlock.offsetLeft + "px" ;
    }else{
      mapBlock.style.width = window.innerWidth - mapBlock.offsetLeft - footerBlock.offsetLeft-15 + "px" ;
    }
  }

  mapResize();

  window.addEventListener('resize', function(event) {
    mapResize();
  }, true);

}